interface EnvConfig {
  API_URL: string;
  API_BASE_URL?: string;
  TENANT_ID?: string;
  MINIJOB_CAP_EUR: number;
  WORKING_STUDENT_MONTHLY_H_CAP: number;
}

const env: EnvConfig = {
  API_URL: import.meta.env.VITE_API_URL || 'http://127.0.0.1:8000',
  API_BASE_URL: import.meta.env.VITE_API_URL || 'http://127.0.0.1:8000',
  TENANT_ID: import.meta.env.VITE_TENANT_ID,
  MINIJOB_CAP_EUR: Number(import.meta.env.VITE_MINIJOB_CAP_EUR || 556),
  WORKING_STUDENT_MONTHLY_H_CAP: Number(import.meta.env.VITE_WORKING_STUDENT_HOURS_CAP || 87),
};

export default env;
